[
  {
    "name": "Afghanistan",
    "code": "AF",
    "region": "Southern Asia"
  },
  {
    "name": "Åland Islands",
    "code": "AX",
    "region": "Northern Europe"
  },
  {
    "name": "Albania",
    "code": "AL",
    "region": "Southeast Europe"
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "region": "Northern Africa"
  },
  {
    "name": "American Samoa",
    "code": "AS",
    "region": "Polynesia"
  },
  {
    "name": "Andorra",
    "code": "AD",
    "region": "Southern Europe"
  },
  {
    "name": "Angola",
    "code": "AO",
    "region": "Middle Africa"
  },
  {
    "name": "Anguilla",
    "code": "AI",
    "region": "Caribbean"
  },
  {
    "name": "Antarctica",
    "code": "AQ"
  },
  {
    "name": "Antigua and Barbuda",
    "code": "AG",
    "region": "Caribbean"
  },
  {
    "name": "Argentina",
    "code": "AR",
    "region": "South America"
  },
  {
    "name": "Armenia",
    "code": "AM",
    "region": "Western Asia"
  },
  {
    "name": "Aruba",
    "code": "AW",
    "region": "Caribbean"
  },
  {
    "name": "Australia",
    "code": "AU",
    "region": "Australia and New Zealand"
  },
  {
    "name": "Austria",
    "code": "AT",
    "region": "Central Europe"
  },
  {
    "name": "Azerbaijan",
    "code": "AZ",
    "region": "Western Asia"
  },
  {
    "name": "Bahamas",
    "code": "BS",
    "region": "Caribbean"
  },
  {
    "name": "Bahrain",
    "code": "BH",
    "region": "Western Asia"
  },
  {
    "name": "Bangladesh",
    "code": "BD",
    "region": "Southern Asia"
  },
  {
    "name": "Barbados",
    "code": "BB",
    "region": "Caribbean"
  },
  {
    "name": "Belarus",
    "code": "BY",
    "region": "Eastern Europe"
  },
  {
    "name": "Belgium",
    "code": "BE",
    "region": "Western Europe"
  },
  {
    "name": "Belize",
    "code": "BZ",
    "region": "Central America"
  },
  {
    "name": "Benin",
    "code": "BJ",
    "region": "Western Africa"
  },
  {
    "name": "Bermuda",
    "code": "BM",
    "region": "North America"
  },
  {
    "name": "Bhutan",
    "code": "BT",
    "region": "Southern Asia"
  },
  {
    "name": "Bolivia",
    "code": "BO",
    "region": "South America"
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BA",
    "region": "Southeast Europe"
  },
  {
    "name": "Botswana",
    "code": "BW",
    "region": "Southern Africa"
  },
  {
    "name": "Bouvet Island",
    "code": "BV"
  },
  {
    "name": "Brazil",
    "code": "BR",
    "region": "South America"
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "IO",
    "region": "Eastern Africa"
  },
  {
    "name": "British Virgin Islands",
    "code": "VG",
    "region": "Caribbean"
  },
  {
    "name": "Brunei",
    "code": "BN",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Bulgaria",
    "code": "BG",
    "region": "Southeast Europe"
  },
  {
    "name": "Burkina Faso",
    "code": "BF",
    "region": "Western Africa"
  },
  {
    "name": "Burundi",
    "code": "BI",
    "region": "Eastern Africa"
  },
  {
    "name": "Cambodia",
    "code": "KH",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Cameroon",
    "code": "CM",
    "region": "Middle Africa"
  },
  {
    "name": "Canada",
    "code": "CA",
    "region": "North America"
  },
  {
    "name": "Cape Verde",
    "code": "CV",
    "region": "Western Africa"
  },
  {
    "name": "Caribbean Netherlands",
    "code": "BQ",
    "region": "Caribbean"
  },
  {
    "name": "Cayman Islands",
    "code": "KY",
    "region": "Caribbean"
  },
  {
    "name": "Central African Republic",
    "code": "CF",
    "region": "Middle Africa"
  },
  {
    "name": "Chad",
    "code": "TD",
    "region": "Middle Africa"
  },
  {
    "name": "Chile",
    "code": "CL",
    "region": "South America"
  },
  {
    "name": "China",
    "code": "CN",
    "region": "Eastern Asia"
  },
  {
    "name": "Christmas Island",
    "code": "CX",
    "region": "Australia and New Zealand"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "code": "CC",
    "region": "Australia and New Zealand"
  },
  {
    "name": "Colombia",
    "code": "CO",
    "region": "South America"
  },
  {
    "name": "Comoros",
    "code": "KM",
    "region": "Eastern Africa"
  },
  {
    "name": "Cook Islands",
    "code": "CK",
    "region": "Polynesia"
  },
  {
    "name": "Costa Rica",
    "code": "CR",
    "region": "Central America"
  },
  {
    "name": "Croatia",
    "code": "HR",
    "region": "Southeast Europe"
  },
  {
    "name": "Cuba",
    "code": "CU",
    "region": "Caribbean"
  },
  {
    "name": "Curaçao",
    "code": "CW",
    "region": "Caribbean"
  },
  {
    "name": "Cyprus",
    "code": "CY",
    "region": "Southern Europe"
  },
  {
    "name": "Czechia",
    "code": "CZ",
    "region": "Central Europe"
  },
  {
    "name": "Denmark",
    "code": "DK",
    "region": "Northern Europe"
  },
  {
    "name": "Djibouti",
    "code": "DJ",
    "region": "Eastern Africa"
  },
  {
    "name": "Dominica",
    "code": "DM",
    "region": "Caribbean"
  },
  {
    "name": "Dominican Republic",
    "code": "DO",
    "region": "Caribbean"
  },
  {
    "name": "DR Congo",
    "code": "CD",
    "region": "Middle Africa"
  },
  {
    "name": "Ecuador",
    "code": "EC",
    "region": "South America"
  },
  {
    "name": "Egypt",
    "code": "EG",
    "region": "Northern Africa"
  },
  {
    "name": "El Salvador",
    "code": "SV",
    "region": "Central America"
  },
  {
    "name": "Equatorial Guinea",
    "code": "GQ",
    "region": "Middle Africa"
  },
  {
    "name": "Eritrea",
    "code": "ER",
    "region": "Eastern Africa"
  },
  {
    "name": "Estonia",
    "code": "EE",
    "region": "Northern Europe"
  },
  {
    "name": "Eswatini",
    "code": "SZ",
    "region": "Southern Africa"
  },
  {
    "name": "Ethiopia",
    "code": "ET",
    "region": "Eastern Africa"
  },
  {
    "name": "Falkland Islands",
    "code": "FK",
    "region": "South America"
  },
  {
    "name": "Faroe Islands",
    "code": "FO",
    "region": "Northern Europe"
  },
  {
    "name": "Fiji",
    "code": "FJ",
    "region": "Melanesia"
  },
  {
    "name": "Finland",
    "code": "FI",
    "region": "Northern Europe"
  },
  {
    "name": "France",
    "code": "FR",
    "region": "Western Europe"
  },
  {
    "name": "French Guiana",
    "code": "GF",
    "region": "South America"
  },
  {
    "name": "French Polynesia",
    "code": "PF",
    "region": "Polynesia"
  },
  {
    "name": "French Southern and Antarctic Lands",
    "code": "TF"
  },
  {
    "name": "Gabon",
    "code": "GA",
    "region": "Middle Africa"
  },
  {
    "name": "Gambia",
    "code": "GM",
    "region": "Western Africa"
  },
  {
    "name": "Georgia",
    "code": "GE",
    "region": "Western Asia"
  },
  {
    "name": "Germany",
    "code": "DE",
    "region": "Western Europe"
  },
  {
    "name": "Ghana",
    "code": "GH",
    "region": "Western Africa"
  },
  {
    "name": "Gibraltar",
    "code": "GI",
    "region": "Southern Europe"
  },
  {
    "name": "Greece",
    "code": "GR",
    "region": "Southern Europe"
  },
  {
    "name": "Greenland",
    "code": "GL",
    "region": "North America"
  },
  {
    "name": "Grenada",
    "code": "GD",
    "region": "Caribbean"
  },
  {
    "name": "Guadeloupe",
    "code": "GP",
    "region": "Caribbean"
  },
  {
    "name": "Guam",
    "code": "GU",
    "region": "Micronesia"
  },
  {
    "name": "Guatemala",
    "code": "GT",
    "region": "Central America"
  },
  {
    "name": "Guernsey",
    "code": "GG",
    "region": "Northern Europe"
  },
  {
    "name": "Guinea",
    "code": "GN",
    "region": "Western Africa"
  },
  {
    "name": "Guinea-Bissau",
    "code": "GW",
    "region": "Western Africa"
  },
  {
    "name": "Guyana",
    "code": "GY",
    "region": "South America"
  },
  {
    "name": "Haiti",
    "code": "HT",
    "region": "Caribbean"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "code": "HM"
  },
  {
    "name": "Honduras",
    "code": "HN",
    "region": "Central America"
  },
  {
    "name": "Hong Kong",
    "code": "HK",
    "region": "Eastern Asia"
  },
  {
    "name": "Hungary",
    "code": "HU",
    "region": "Central Europe"
  },
  {
    "name": "Iceland",
    "code": "IS",
    "region": "Northern Europe"
  },
  {
    "name": "India",
    "code": "IN",
    "region": "Southern Asia"
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Iran",
    "code": "IR",
    "region": "Southern Asia"
  },
  {
    "name": "Iraq",
    "code": "IQ",
    "region": "Western Asia"
  },
  {
    "name": "Ireland",
    "code": "IE",
    "region": "Northern Europe"
  },
  {
    "name": "Isle of Man",
    "code": "IM",
    "region": "Northern Europe"
  },
  {
    "name": "Israel",
    "code": "IL",
    "region": "Western Asia"
  },
  {
    "name": "Italy",
    "code": "IT",
    "region": "Southern Europe"
  },
  {
    "name": "Ivory Coast",
    "code": "CI",
    "region": "Western Africa"
  },
  {
    "name": "Jamaica",
    "code": "JM",
    "region": "Caribbean"
  },
  {
    "name": "Japan",
    "code": "JP",
    "region": "Eastern Asia"
  },
  {
    "name": "Jersey",
    "code": "JE",
    "region": "Northern Europe"
  },
  {
    "name": "Jordan",
    "code": "JO",
    "region": "Western Asia"
  },
  {
    "name": "Kazakhstan",
    "code": "KZ",
    "region": "Central Asia"
  },
  {
    "name": "Kenya",
    "code": "KE",
    "region": "Eastern Africa"
  },
  {
    "name": "Kiribati",
    "code": "KI",
    "region": "Micronesia"
  },
  {
    "name": "Kosovo",
    "code": "XK",
    "region": "Southeast Europe"
  },
  {
    "name": "Kuwait",
    "code": "KW",
    "region": "Western Asia"
  },
  {
    "name": "Kyrgyzstan",
    "code": "KG",
    "region": "Central Asia"
  },
  {
    "name": "Laos",
    "code": "LA",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Latvia",
    "code": "LV",
    "region": "Northern Europe"
  },
  {
    "name": "Lebanon",
    "code": "LB",
    "region": "Western Asia"
  },
  {
    "name": "Lesotho",
    "code": "LS",
    "region": "Southern Africa"
  },
  {
    "name": "Liberia",
    "code": "LR",
    "region": "Western Africa"
  },
  {
    "name": "Libya",
    "code": "LY",
    "region": "Northern Africa"
  },
  {
    "name": "Liechtenstein",
    "code": "LI",
    "region": "Western Europe"
  },
  {
    "name": "Lithuania",
    "code": "LT",
    "region": "Northern Europe"
  },
  {
    "name": "Luxembourg",
    "code": "LU",
    "region": "Western Europe"
  },
  {
    "name": "Macau",
    "code": "MO",
    "region": "Eastern Asia"
  },
  {
    "name": "Madagascar",
    "code": "MG",
    "region": "Eastern Africa"
  },
  {
    "name": "Malawi",
    "code": "MW",
    "region": "Eastern Africa"
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Maldives",
    "code": "MV",
    "region": "Southern Asia"
  },
  {
    "name": "Mali",
    "code": "ML",
    "region": "Western Africa"
  },
  {
    "name": "Malta",
    "code": "MT",
    "region": "Southern Europe"
  },
  {
    "name": "Marshall Islands",
    "code": "MH",
    "region": "Micronesia"
  },
  {
    "name": "Martinique",
    "code": "MQ",
    "region": "Caribbean"
  },
  {
    "name": "Mauritania",
    "code": "MR",
    "region": "Western Africa"
  },
  {
    "name": "Mauritius",
    "code": "MU",
    "region": "Eastern Africa"
  },
  {
    "name": "Mayotte",
    "code": "YT",
    "region": "Eastern Africa"
  },
  {
    "name": "Mexico",
    "code": "MX",
    "region": "North America"
  },
  {
    "name": "Micronesia",
    "code": "FM",
    "region": "Micronesia"
  },
  {
    "name": "Moldova",
    "code": "MD",
    "region": "Eastern Europe"
  },
  {
    "name": "Monaco",
    "code": "MC",
    "region": "Western Europe"
  },
  {
    "name": "Mongolia",
    "code": "MN",
    "region": "Eastern Asia"
  },
  {
    "name": "Montenegro",
    "code": "ME",
    "region": "Southeast Europe"
  },
  {
    "name": "Montserrat",
    "code": "MS",
    "region": "Caribbean"
  },
  {
    "name": "Morocco",
    "code": "MA",
    "region": "Northern Africa"
  },
  {
    "name": "Mozambique",
    "code": "MZ",
    "region": "Eastern Africa"
  },
  {
    "name": "Myanmar",
    "code": "MM",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Namibia",
    "code": "NA",
    "region": "Southern Africa"
  },
  {
    "name": "Nauru",
    "code": "NR",
    "region": "Micronesia"
  },
  {
    "name": "Nepal",
    "code": "NP",
    "region": "Southern Asia"
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "region": "Western Europe"
  },
  {
    "name": "New Caledonia",
    "code": "NC",
    "region": "Melanesia"
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "region": "Australia and New Zealand"
  },
  {
    "name": "Nicaragua",
    "code": "NI",
    "region": "Central America"
  },
  {
    "name": "Niger",
    "code": "NE",
    "region": "Western Africa"
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "region": "Western Africa"
  },
  {
    "name": "Niue",
    "code": "NU",
    "region": "Polynesia"
  },
  {
    "name": "Norfolk Island",
    "code": "NF",
    "region": "Australia and New Zealand"
  },
  {
    "name": "North Korea",
    "code": "KP",
    "region": "Eastern Asia"
  },
  {
    "name": "North Macedonia",
    "code": "MK",
    "region": "Southeast Europe"
  },
  {
    "name": "Northern Mariana Islands",
    "code": "MP",
    "region": "Micronesia"
  },
  {
    "name": "Norway",
    "code": "NO",
    "region": "Northern Europe"
  },
  {
    "name": "Oman",
    "code": "OM",
    "region": "Western Asia"
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "region": "Southern Asia"
  },
  {
    "name": "Palau",
    "code": "PW",
    "region": "Micronesia"
  },
  {
    "name": "Palestine",
    "code": "PS",
    "region": "Western Asia"
  },
  {
    "name": "Panama",
    "code": "PA",
    "region": "Central America"
  },
  {
    "name": "Papua New Guinea",
    "code": "PG",
    "region": "Melanesia"
  },
  {
    "name": "Paraguay",
    "code": "PY",
    "region": "South America"
  },
  {
    "name": "Peru",
    "code": "PE",
    "region": "South America"
  },
  {
    "name": "Philippines",
    "code": "PH",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Pitcairn Islands",
    "code": "PN",
    "region": "Polynesia"
  },
  {
    "name": "Poland",
    "code": "PL",
    "region": "Central Europe"
  },
  {
    "name": "Portugal",
    "code": "PT",
    "region": "Southern Europe"
  },
  {
    "name": "Puerto Rico",
    "code": "PR",
    "region": "Caribbean"
  },
  {
    "name": "Qatar",
    "code": "QA",
    "region": "Western Asia"
  },
  {
    "name": "Republic of the Congo",
    "code": "CG",
    "region": "Middle Africa"
  },
  {
    "name": "Réunion",
    "code": "RE",
    "region": "Eastern Africa"
  },
  {
    "name": "Romania",
    "code": "RO",
    "region": "Southeast Europe"
  },
  {
    "name": "Russia",
    "code": "RU",
    "region": "Eastern Europe"
  },
  {
    "name": "Rwanda",
    "code": "RW",
    "region": "Eastern Africa"
  },
  {
    "name": "Saint Barthélemy",
    "code": "BL",
    "region": "Caribbean"
  },
  {
    "name": "Saint Helena, Ascension and Tristan da Cunha",
    "code": "SH",
    "region": "Western Africa"
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "KN",
    "region": "Caribbean"
  },
  {
    "name": "Saint Lucia",
    "code": "LC",
    "region": "Caribbean"
  },
  {
    "name": "Saint Martin",
    "code": "MF",
    "region": "Caribbean"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "PM",
    "region": "North America"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "VC",
    "region": "Caribbean"
  },
  {
    "name": "Samoa",
    "code": "WS",
    "region": "Polynesia"
  },
  {
    "name": "San Marino",
    "code": "SM",
    "region": "Southern Europe"
  },
  {
    "name": "São Tomé and Príncipe",
    "code": "ST",
    "region": "Middle Africa"
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "region": "Western Asia"
  },
  {
    "name": "Senegal",
    "code": "SN",
    "region": "Western Africa"
  },
  {
    "name": "Serbia",
    "code": "RS",
    "region": "Southeast Europe"
  },
  {
    "name": "Seychelles",
    "code": "SC",
    "region": "Eastern Africa"
  },
  {
    "name": "Sierra Leone",
    "code": "SL",
    "region": "Western Africa"
  },
  {
    "name": "Singapore",
    "code": "SG",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Sint Maarten",
    "code": "SX",
    "region": "Caribbean"
  },
  {
    "name": "Slovakia",
    "code": "SK",
    "region": "Central Europe"
  },
  {
    "name": "Slovenia",
    "code": "SI",
    "region": "Central Europe"
  },
  {
    "name": "Solomon Islands",
    "code": "SB",
    "region": "Melanesia"
  },
  {
    "name": "Somalia",
    "code": "SO",
    "region": "Eastern Africa"
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "region": "Southern Africa"
  },
  {
    "name": "South Georgia",
    "code": "GS"
  },
  {
    "name": "South Korea",
    "code": "KR",
    "region": "Eastern Asia"
  },
  {
    "name": "South Sudan",
    "code": "SS",
    "region": "Middle Africa"
  },
  {
    "name": "Spain",
    "code": "ES",
    "region": "Southern Europe"
  },
  {
    "name": "Sri Lanka",
    "code": "LK",
    "region": "Southern Asia"
  },
  {
    "name": "Sudan",
    "code": "SD",
    "region": "Northern Africa"
  },
  {
    "name": "Suriname",
    "code": "SR",
    "region": "South America"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "code": "SJ",
    "region": "Northern Europe"
  },
  {
    "name": "Sweden",
    "code": "SE",
    "region": "Northern Europe"
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "region": "Western Europe"
  },
  {
    "name": "Syria",
    "code": "SY",
    "region": "Western Asia"
  },
  {
    "name": "Taiwan",
    "code": "TW",
    "region": "Eastern Asia"
  },
  {
    "name": "Tajikistan",
    "code": "TJ",
    "region": "Central Asia"
  },
  {
    "name": "Tanzania",
    "code": "TZ",
    "region": "Eastern Africa"
  },
  {
    "name": "Thailand",
    "code": "TH",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Timor-Leste",
    "code": "TL",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Togo",
    "code": "TG",
    "region": "Western Africa"
  },
  {
    "name": "Tokelau",
    "code": "TK",
    "region": "Polynesia"
  },
  {
    "name": "Tonga",
    "code": "TO",
    "region": "Polynesia"
  },
  {
    "name": "Trinidad and Tobago",
    "code": "TT",
    "region": "Caribbean"
  },
  {
    "name": "Tunisia",
    "code": "TN",
    "region": "Northern Africa"
  },
  {
    "name": "Turkey",
    "code": "TR",
    "region": "Western Asia"
  },
  {
    "name": "Turkmenistan",
    "code": "TM",
    "region": "Central Asia"
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "TC",
    "region": "Caribbean"
  },
  {
    "name": "Tuvalu",
    "code": "TV",
    "region": "Polynesia"
  },
  {
    "name": "Uganda",
    "code": "UG",
    "region": "Eastern Africa"
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "region": "Eastern Europe"
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "region": "Western Asia"
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "region": "Northern Europe"
  },
  {
    "name": "United States",
    "code": "US",
    "region": "North America"
  },
  {
    "name": "United States Minor Outlying Islands",
    "code": "UM",
    "region": "North America"
  },
  {
    "name": "United States Virgin Islands",
    "code": "VI",
    "region": "Caribbean"
  },
  {
    "name": "Uruguay",
    "code": "UY",
    "region": "South America"
  },
  {
    "name": "Uzbekistan",
    "code": "UZ",
    "region": "Central Asia"
  },
  {
    "name": "Vanuatu",
    "code": "VU",
    "region": "Melanesia"
  },
  {
    "name": "Vatican City",
    "code": "VA",
    "region": "Southern Europe"
  },
  {
    "name": "Venezuela",
    "code": "VE",
    "region": "South America"
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "region": "South-Eastern Asia"
  },
  {
    "name": "Wallis and Futuna",
    "code": "WF",
    "region": "Polynesia"
  },
  {
    "name": "Western Sahara",
    "code": "EH",
    "region": "Northern Africa"
  },
  {
    "name": "Yemen",
    "code": "YE",
    "region": "Western Asia"
  },
  {
    "name": "Zambia",
    "code": "ZM",
    "region": "Eastern Africa"
  },
  {
    "name": "Zimbabwe",
    "code": "ZW",
    "region": "Southern Africa"
  }
]
